/**
 * @type {RegExp} regex pattern for validating email address
 */
export const emailRegex = /^[A-Z0-9.!#$%&'+\/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i

/**
 * @type {RegExp} regex for number letters and limited spcl character
 */
export const allowedSpclCharsRegex = /^[A-Za-z0-9\s-()+&@.,]+$/

/**
 * @type {RegExp} regex for replacing not allowed character
 */
export const replaceSpclCharsRegex = /[^A-Za-z0-9\s-()+&@.,]/g

/**
 * @type {RegExp} regex for number letters and limited spcl character
 */
export const allowedSpclCharsRegexInMultiSigner = /^[A-Za-z\s.'-]+$/

/**
 * @type {RegExp} regex for replacing not allowed character
 */
export const replaceSpclCharsRegexInMultiSigner = /[^A-Za-z\s.'-]/g
